import { faWarning } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useGetLastVisitedQuery } from 'API/order/VisitTrackingAPI';
import { useGetSectionDataQuery } from 'API/order/fees/FeeApi';
import { DateTime } from 'luxon';
import React from 'react';
import { DateFormat } from '../../../ui-toolkit/utilities/getDateString';

export interface IFeesUpdatedAtProps {
  orderId: string;
}

const getDateFromItem = (item: { createdAt: string; updatedAt?: string }) => {
  if (item.updatedAt) {
    if (item.updatedAt > item.createdAt) {
      return item.updatedAt;
    }
  }

  return item.createdAt;
};

export const FeesUpdatedAt: React.FC<IFeesUpdatedAtProps> = ({ orderId }) => {
  const { data: value } = useGetLastVisitedQuery(orderId);
  const { data = [] } = useGetSectionDataQuery(orderId);
  const sectionLatest = data.map(getDateFromItem).reduce((date, newDate) => (date > newDate ? date : newDate), '');
  const lineItemLatest = data
    .flatMap((t) => t.statementSettlementItems.map(getDateFromItem))
    .reduce((date, newDate) => (date > newDate ? date : newDate), '');
  const latestFeeDate = sectionLatest > lineItemLatest ? sectionLatest : lineItemLatest;
  const isoLatestFee = DateTime.fromISO(`${latestFeeDate}Z`);
  const isoLatestVisit = value && DateTime.fromISO(value);
  const liteMeUp = isoLatestVisit && isoLatestFee > isoLatestVisit;
  return (
    <>
      {data.length > 0 && (
        <div
          className={liteMeUp ? 'text-red-800' : ''}
          title={isoLatestFee.toFormat(DateFormat.shortDateTime)}
          data-test-id={'Jump Column Fees Last Updated At'}
        >
          {isoLatestFee.toLocal().toFormat(DateFormat.short)}{' '}
          {liteMeUp && <FontAwesomeIcon data-test-id={'Jump Fees Warning'} icon={faWarning} />}
        </div>
      )}
    </>
  );
};
